__turbopack_context__.v({
  "container": "vE2arq_container",
  "content": "vE2arq_content",
  "controls": "vE2arq_controls",
  "heading": "vE2arq_heading",
  "list": "vE2arq_list",
  "pageNumber": "vE2arq_pageNumber",
  "title": "vE2arq_title",
  "top": "vE2arq_top",
});
